export default __webpack_public_path__ + "static/media/Muli.4829cf81.ttf";